import React, { useState } from "react";
import "../../css/terms.scss";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Terms = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <Header />
      <div className="terms_main">
        <section id="revision_history">
          <h3
            data-gtm-vis-first-on-screen9678464_101={151}
            data-gtm-vis-recent-on-screen9678464_101={5874}
            data-gtm-vis-total-visible-time9678464_101={100}
            data-gtm-vis-has-fired9678464_101={1}
          >
            改定履歴
          </h3>
          <ul>
            <li>2015年03月20日 制定・発効</li>
            <li>2015年11月04日 改定</li>
            <li>2017年02月01日 改定</li>
            <li>2019年05月24日 改定</li>
            <li>2019年12月09日 改定</li>
            <li>2019年03月06日 改定</li>
            <li>2020年12月18日 改定</li>
            <li>2021年03月25日 改定</li>
            <li>2021年08月16日 改定</li>
            <li>2021年11月24日 改定</li>
            <li>2022年03月01日 改定</li>
            <li>2022年09月29日 改定</li>
            <li>2023年05月09日 改定</li>
            <li>2023年06月06日 改定</li>
            <li>2024年04月01日 改定</li>
            <li>2025年05月27日 改定</li>
          </ul>
        </section>
        <section id="norm">
          <h1
            data-gtm-vis-first-on-screen9678464_101={153}
            data-gtm-vis-recent-on-screen9678464_101={5619}
            data-gtm-vis-total-visible-time9678464_101={100}
            data-gtm-vis-has-fired9678464_101={1}
          >
            READYFOR利用規約
          </h1>
          <div className="description">
            　READYFOR株式会社（以下「RF」といいます。）は、RFが提供するクラウドファンディングサービス「READYFOR」（以下「本CFサービス」といいます。）について以下のとおり「READYFOR利用規約」（以下「本規約」といいます。）を定めます。本CFサービスのユーザー（以下「ユーザー」といいます。）は、本規約の定めに従って本CFサービスを利用するものとします。
            <br />
            　なお、本CFサービスは、
            <Link onClick={toTop} to="/terms">
              「RFサービス共通規約」
            </Link>
            において定義される「本サービス」の一部であり、本CFサービスのユーザーは、本規約のほか「RFサービス共通規約」の定めにも従って本CFサービスを利用するものとします。また、本規約上で使用される用語は、本規約上で別途定める場合を除き、「RFサービス共通規約」で定義された意味と同一の意味を有するものとします。
            <br />
          </div>
          <div className="paragraph">
            <h2>目次</h2>
            <div className="body">
              <a href="#issyo">
                <font color="black">第1章　総則</font>
              </a>
              <br />
              <a href="#nisyo">
                <font color="black">第2章　本CFサービスの内容</font>
              </a>
              <br />
              <a href="#sansyo">
                <font color="black">第3章　実行者に関するルール</font>
              </a>
              <br />
              <a href="#yonsyo">
                <font color="black">第4章　オプションサービス</font>
              </a>
              <br />
              <a href="#gosyo">
                <font color="black">第5章　支援者に関するルール</font>
              </a>
              <br />
              <a href="#rokusyo">
                <font color="black">第6章　その他</font>
              </a>
              <br />
              <a href="#betten">
                <font color="black">別添　支援契約について</font>
              </a>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="issyo" />
                <h2 style={{ textAlign: "center" }}> 第1章　総則</h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第1条（定義）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                本規約において用いる用語の意味は、以下のとおりとします。
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1) 「All
                In方式」とは、支援総額が目標金額に達したか否かにかかわらず、1円以上の支援があった場合にクラウドファンディングが達成したものとして取り扱われるクラウドファンディングの実施方式をいいます。
                <br />
                (2) 「All or
                Nothing方式」とは、支援総額が目標金額に達した場合に限ってクラウドファンディングが達成したものとして取り扱われるクラウドファンディングの実施方式をいいます。
                <br />
                (3) 「クラウドファンディングの達成」とは、All or
                Nothing方式で実施されているクラウドファンディングでは支援総額が目標金額に達することをいい、All
                In方式で実施されているクラウドファンディングでは支援総額が1円に達することをいいます。
                <br />
                (4)
                「クラウドファンディングの成立」とは、クラウドファンディングが達成し、かつ、クラウドファンディングが中止されることなく支援募集期間が満了することをいいます。
                <br />
                (5)
                「支援」とは、本CFサービス上で公開されているクラウドファンディングに対して実行者への金員（以下「支援金」といいます。）を支払うことを目的としたRF所定の行為をいいます。
                <br />
                (6)
                「支援契約」とは、支援者が本CFサービス上でクラウドファンディングに対する支援を行った場合に支援者と実行者との間で成立する契約をいいます。
                <br />
                (7)
                「支援者」とは、登録ユーザーのうち、本CFサービス上でクラウドファンディングに対する支援を行い、又は支援を行うことを希望する者をいいます。
                <br />
                (8)
                「支援総額」とは、特定のクラウドファンディングに関して支援が行われた支援金の合計額をいいます。
                <br />
                (9)
                「支援募集期間」とは、実行者が本CFサービス上でクラウドファンディングに関して支援を募集する期間をいいます。
                <br />
                (10)
                「実行者」とは、登録ユーザーのうち、本CFサービス上でクラウドファンディングを実施し、又は実施することを希望する者をいいます。
                <br />
                (11)
                「プロジェクト」とは、実行者が支援金を使用して実行する企画、団体の運営その他の取組みをいいます。
                <br />
                (12)
                「プロジェクト実施完了日」とは、実行者がクラウドファンディングの公開に際して、プロジェクトの実施日又は期日としてRF所定の方法によりRFに通知した日をいいます。
                <br />
                (13)
                「プロジェクトページ」とは、プロジェクトの内容、リターンの内容、目標金額、支援金の使途、支援募集期間その他RF所定の事項が記載されたウェブサイトをいいます。なお、「プロジェクト概要」の名称で公表されているウェブサイトのほか、「活動報告」、「応援コメント」、「終了報告」の名称で公表されているウェブサイトを含みます。
                <br />
                (14)「ベーシックプラン」とは、実行者向けのサービスプランのうちRFの専任担当者（サポートプランが適用される場合において、実行者に対して
                (i)プロジェクトページの作成の助言、(ii)リターンの設計の助言、(iii)クラウドファンディングの実施中の広報戦略の助言その他のRF所定のサポートを行うコンサルタントをいいます。以下同じ。）によるサポートを受けないサービスプランをいいます。
                <br />
                (15)
                「サポートプラン」とは、実行者向けのサービスプランのうち、RFの専任担当者によるサポートのあるサービスプランをいいます。
                <br />
                (16)
                「コンサルティングプラン」とは、実行者向けのサービスプランのうち、RFの専任担当者によるサポートのあるサービスプランであって、サポートプランのサポート内容に加え、クラウドファンディングのコンセプト及びクラウドファンディング実施中の戦略に関するより詳細な助言その他のRF所定のサポートを行うサービスプランをいいます。
                <br />
                (17)
                「目標金額」とは、実行者がクラウドファンディングにおいて募集する支援総額の目標金額をいいます。なお、ネクストゴールが設定された場合でも、目標金額は変更されません。
                <br />
                (18)
                「リターン」とは、実行者が支援者に対して提供する物、役務又は権利をいいます。
                <br />
              </p>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              {" "}
              <span style={{ fontSize: "150%" }}>
                <h2 id="nisyo" />
                <h2 style={{ textAlign: "center" }}>
                  第2章　本CFサービスの内容
                </h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第2条（本CFサービスの概要及び利用）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                本CFサービスは、実行者がクラウドファンディングを実施して支援者から支援を受け付け、支援者がクラウドファンディングに対する支援を行い、また、実行者と支援者が交流する場や機会を提供するサービスです。
                <br />
                <br />
                2.
                ユーザーが実行者としてクラウドファンディングを実施し、又は支援者としてクラウドファンディングに対して支援を行うためには、ユーザー登録を完了する必要があります。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第3条（支援契約及びRFの立場）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                本CFサービス上でクラウドファンディングに対する支援が行われた場合、本規約の定めに従って実行者と支援者との間で支援契約が成立します。
                <br />
                <br />
                2.
                支援契約は、支援者が実行者に対して支援金を支払うこと、並びに、実行者が支援者に対し、プロジェクトページの内容に従ったプロジェクトの実行、支援金の使用及びリターンの提供を行うことを主な内容とします。なお、別添「支援契約について」に定める内容は支援契約の内容を構成するものとします。
                <br />
                <br />
                3.
                支援契約に基づく権利の行使及び義務の履行は、支援者及び実行者がそれぞれ自己の責任と費用の負担において行うものとします。支援者は、プロジェクトの実行、支援金の使用、リターンの提供その他の支援契約に関する事項については、本CFサービスのメッセージ機能を利用する方法その他の方法により直接実行者に一次的な問合せを行うものとします。
                <br />
                <br />
                4.
                RFは支援契約の当事者となるものではなく、支援契約に基づく義務（プロジェクトの実行やリターンの提供を含みます。）及び責任を負わず、また、支援契約に基づく義務が履行されることを保証するものではありません。
                <br />
                <br />
                5.
                支援契約に起因又は関連して紛争（プロジェクトの実行又はリターンの提供の遅延を含みます。）が発生した場合であっても、RFはその解決のためのあっせん、調停、仲裁その他の紛争解決の手段を講じる義務及び責任（本CFサービスのシステム上で支援をキャンセルする義務及び責任を含みます。）を負うものではありません。
                <br />
                <br />
                6.
                何らかの理由により支援者が実行者に対して支援金の返金を求め、又は実行者が支援者に対して支援金の返金を行う場合、RFが特別に認めた場合を除き、実行者及び支援者において返金の要否並びに返金を行う時期及び方法について協議の上決定し、実行者の費用及び責任において実行者自ら支援金の返金を実施するものとします。RFは、顧客サービスの一環として返金の円滑な実施をサポートすることはあるものの、支援者に対し、実行者の支援者に対する返金が適切に行われることを保証するものではありません。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第4条（支援金の収納代行）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                実行者は、RFに対して、支援者から支援契約に基づき支払われる支援金を実行者に代わって受領するための代理受領権限を付与するものとします。RFが支援金を実行者に代わって受領した時点で、支援者の支援金支払義務の履行は完了します。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="sansyo" />
                <h2 style={{ textAlign: "center" }}>
                  {" "}
                  第3章　実行者に関するルール
                </h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第5条（サポートプラン・コンサルティングプラン）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者がサポートプラン又はコンサルティングプランの利用を希望する場合、RF所定の方法によりその申請を行うものとします。RFがサポートプラン又はコンサルティングプランの申請を承認した場合、実行者に当該プランが適用されます。
                <br />
                <br />
                2.
                RFは、RFの判断でサポートプラン又はコンサルティングプランの申請を承認せず、また、事後的に承認を取り消すことができるものとします。この場合であっても、RFは承認を拒否し、又は取り消した理由を開示する義務を負いません。
                <br />
                <br />
                3.
                実行者にサポートプラン又はコンサルティングプランが適用された場合、RFが承認した場合を除き、実行者が当該プランの利用をキャンセルすることはできないものとします。
                <br />
                <br />
                4.
                実行者が専任担当者の変更を希望した場合であっても、RFは専任担当者の変更に応じる義務を負いません。また、専任担当者は複数の実行者に対して同時にサポートを行う場合があるほか、RFはその判断で専任担当者を変更する場合があります。
                <br />
                <br />
                5.
                実行者にサポートプラン又はコンサルティングプランが適用される場合、以下に定めるときは、キャンセル料として、RFはその判断により以下の金額（税別）を実行者に対して請求することができるものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)
                実行者が専任担当者のサポートを受けてRF所定の方法によりクラウドファンディングの公開準備を開始した後、実行者の都合によりクラウドファンディングの公開準備を中止した場合　30,000円
                <br />
                (2)
                クラウドファンディングの公開後に実行者の都合によりクラウドファンディングを中止した場合　50,000円
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                6.
                実行者にサポートプラン又はコンサルティングプランが適用される場合において、実行者が専任担当者のサポートを受けた後に、クラウドファンディングの公開準備を行わず、又はこれを中止したときは、その旨を速やかにRFに報告するものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第6条（クラウドファンディングの類型）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1. 実行者は、RFが承認した場合に限り、All
                In方式でクラウドファンディングを公開することができるものとします。
                <br />
                <br />
                2.
                実行者は、RFが承認した場合に限り、寄付金控除型クラウドファンディング（支援者が寄付金控除、ふるさと納税などの税制上の優遇措置を受けられる類型）としてクラウドファンディングを公開できるものとします。実行者が寄付金控除型クラウドファンディングを公開する場合、実行者は、税務専門家、所轄官庁などの必要な確認を行うとともに、プロジェクトページ上で税制上の優遇措置について必要な説明を行うものとします。なお、寄付金控除型クラウドファンディングについては、本規約の適用上「支援」を「寄付」と読み替え、「リターン」を「ギフト」と読み替えるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第7条（クラウドファンディングに関する情報の入力）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者が本CFサービス上でクラウドファンディングを実施する場合、RF所定の方法により必要な情報（以下の情報を含みます。）を入力し、RFに送信する必要があります。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)
                実行者の情報、緊急連絡先の情報、振込先口座の情報、プロジェクトに関する情報
                <br />
                (2)
                プロジェクトページに関する情報（プロジェクト、支援金の使途、リターン等）
                <br />
                (3)
                支援募集期間、目標金額、プロジェクト実施完了日などのクラウドファンディングに関する情報
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                2.
                RFは、前項に定める情報入力について不備（RF所定の基準への抵触を含みます。）があった場合、実行者に対してその追加、修正、削除等を求めることができるものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第8条（プロジェクトページ）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、プロジェクトページに、プロジェクトの内容、リターンの内容、支援金の使途その他のRF所定の事項を記載するものとします。
                <br />
                <br />
                2.
                実行者は、事実に基づき正確にプロジェクトページを作成するものとします。実行者は、プロジェクトページ上に虚偽又は誇大な情報、正確性、真実性に疑義のある情報、誤認又は誤導のおそれがある情報を記載してはなりません。
                <br />
                <br />
                3.
                実行者は、景品表示法（不当景品類及び不当表示防止法）、薬機法（医薬品、医療機器等の品質、有効性及び安全性の確保等に関する法律）、特商法（特定商取引に関する法律）その他の関係法令を遵守してプロジェクトページを作成するものとします。なお、実行者が特定商取引法上の「販売業者又は役務提供事業者」に該当する場合、同法の定めに従い必要な表記をプロジェクトページ又はプロジェクトページからリンクで遷移できるウェブページに掲載するものとします。また、支援者から同法に基づき同法所定の事項の提供が求められた場合、実行者は遅滞なくこれに応じるものとし、RFが当該請求を行った支援者に対してかかる情報を提供した場合でも異議を述べないものとします。
                <br />
                <br />
                4.
                実行者は、プロジェクトの実行、リターンの提供を完了できず、又は遅延を生じさせる具体的なおそれを認識している場合、プロジェクトページで必要な説明を行うものとします。
                <br />
                <br />
                5.
                実行者は、プロジェクトページに文章、写真その他の画像・動画を利用することで第三者の著作権、肖像権・パブリシティ権、プライバシー、名誉・信用その他の権利を侵害してはならないものとします。著作権者その他の権利者が存在する文章、写真その他の画像・動画をプロジェクトページに利用する場合、実行者は利用に先立ち権利者の承諾を得るなど必要な権利処理を行うものとします。
                <br />
                <br />
                6.
                実行者は、プロジェクトページ上で以下に該当する表現を行ってはならないものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)過度に暴力的な表現、露骨な性的表現
                <br />
                (2)人種、国籍、信条、性別、社会的身分、門地等による差別につながる表現
                <br />
                (3)自殺、自傷行為を誘引又は助長する表現
                <br />
                (4)薬物乱用その他の犯罪行為及び刑罰法令に抵触する行為を誘引又は助長する表現
                <br />
                (5)投機、射幸心をあおる表現
                <br />
                (6)反社会的、公序良俗に違反する表現
                <br />
                (7)その他RFが不適切であると合理的に判断する表現
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第9条（プロジェクト及びリターン）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                実行者は、RFに対し、プロジェクトページの内容に従ってプロジェクトを実行し、また、リターンを提供することについて以下の各事項が真実かつ正確であることを表明し、保証するものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)
                関係法令に違反せず、また、違反するおそれがない（必要な許認可等が存在する場合、当該許認可等を取得できる具体的な見込みが存在する）こと。
                <br />
                (2)
                第三者の著作権、肖像権・パブリシティ権、プライバシー、名誉・信用その他の権利を侵害せず、また、侵害するおそれがない（権利者の承諾など必要な権利処理が存在する場合、当該権利処理を実施できる具体的な見込みが存在する）こと。
                <br />
                (3)
                第三者との間で締結している契約や実行者に適用される規則、規程等に違反せず、また、違反するおそれがないこと。
                <br />
                (4)
                プロジェクトページに明示した事項を除き、プロジェクトを実行できず、又はリターンを提供できない具体的なおそれが生じていないこと。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第10条（公開前審査）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者が本CFサービス上でクラウドファンディングを公開するためには、RF所定の公開前審査を通過する必要があります。
                <br />
                <br />
                2.
                RFは、実行者、プロジェクト、リターンその他の事項についてRF所定の公開基準を充たさず、又はそのおそれがあると判断する場合（実行者が前項に定める情報提供又は資料の提出の求めに応じない場合を含みます。）、公開前審査を不通過とすることができます。この場合であっても、RFは公開前審査を不通過とした理由を開示する義務を負いません。
                <br />
                <br />
                3.
                RFは、前項に定める判断に必要な範囲で実行者に対して情報提供又は資料の提出を求めることができるものとします。また、RFは、RFと第三者との間で締結する契約への抵触の有無を確認することを目的として、合理的に必要な範囲で決済代行会社その他の第三者にクラウドファンディングに関する資料を提出することができるものとし、実行者はこれに異議を述べないものとします。
                <br />
                <br />
                4.
                RFは、公開前審査を通過させた場合であっても、事後的にRF所定の公開基準に抵触する事情が判明した場合その他これに準じる事由が生じた場合、実行者に対する追加の情報提供又は資料の提出、プロジェクトページの修正、追記、削除、実行者との協議の要請、クラウドファンディングの公開の不承認、クラウドファンディングの中止その他の必要な措置を行うことができるものとします。
                <br />
                <br />
                5.
                実行者によるクラウドファンディングに関する広告・宣伝について、本規約の定めに従いRFが公開前審査を不通過とすることができる場合又は本規約の定めに従いRFが公開前審査を通過させた後に必要な措置を行うことができる場合、RFは以下に掲げる措置を講ずることができるものとし、実行者はこれに対して異議を述べないものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)実行者に対し、実行者が本CFサービス上で公開しようとするクラウドファンディングに関する広告・宣伝を行わないように要請すること、または、すでに行われている当該広告・宣伝の修正又は削除を要請すること。
                <br />
                (2)RFが本CFサービス上で提供する機能（クラウドファンディングの公開前に作成中のプロジェクトページを外部から閲覧可能にする機能を含みます。）の全部又は一部の提供停止
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第11条（プロジェクトページの公開等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者が本CFサービス上でクラウドファンディングを実施するためには、プロジェクトページを公開する必要があります。
                <br />
                <br />
                2.
                実行者は、RFの承認を得た場合に限り、プロジェクトページの公開を開始することができるものとします。
                <br />
                <br />
                3.
                実行者がプロジェクトページの公開前に書面又は電磁的方法によりRFによるクラウドファンディングの広告・宣伝を希望しない旨を通知した場合を除き、RFは、RFの管理するSNSアカウントを通じてクラウドファンディングの紹介を行い、また、RFの利用するサービスを利用してクラウドファンディングの広告・宣伝を行うことができるものとします。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第12条（クラウドファンディングの達成及び成立）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1. All or Nothing方式では支援総額が目標金額に達した時点で、All
                In方式では支援総額が1円に達した時点でクラウドファンディングは達成したものとして取り扱われます。
                <br />
                <br />
                2.
                クラウドファンディングの達成後、クラウドファンディングが中止されることなく支援募集期間を満了した場合、クラウドファンディングは成立したものとして取り扱われます。
                <br />
                <br />
                3.
                支援募集期間中にクラウドファンディングが達成しないまま支援募集期間を満了した場合、クラウドファンディングは不成立となり、RFは支援者に対する返金その他の必要な措置を講じます。なお、この場合、実行者のRFに対するクラウドファンディング実施手数料は発生しません。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第13条（ネクストゴール）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、支援募集期間中、支援総額が目標金額に達したことを条件として、RFの承認を得た上で目標金額以降の次なる支援総額の目標（以下「ネクストゴール」といいます。）を設定することができます。なお、実行者がネクストゴールを設定する場合、プロジェクトページにネクストゴールの資金使途など必要な事項を追加することを要するものとします。
                <br />
                <br />
                2.
                支援総額がネクストゴールに達しなかった場合でも、クラウドファンディングの達成の有無には影響しません。
                <br />
                <br />
                3.
                支援総額がネクストゴールに達した場合において、実行者がさらなる支援総額の目標を設定することを希望した場合も前二項の定めに準じて取り扱われます。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第14条（プロジェクトページの変更等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、クラウドファンディングの開始後は、RFが特別に認めた場合を除き、目標金額及び支援募集期間を変更することができないことを確認するものとします。
                <br />
                <br />
                2.
                実行者は、クラウドファンディングの開始後は、RFの承認を得た場合に限り、プロジェクトページの内容の追加、修正、削除等を行うことができるものとします。
                <br />
                <br />
                3.
                実行者は、クラウドファンディングの開始後は、RFの承認を得た場合に限り、リターンの追加、削除、内容の変更、個数の変更を行うことができるものとします。なお、実行者が既に支援者が存在するリターンをRFの承認を得て変更又は削除する場合、自己の責任で当該支援者の個別の同意を得るものとし、同意が得られない場合は自己の責任で返金その他の必要な対応をとるものとします。
                <br />
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第15条（自己支援の禁止等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、RFが特別に認めた場合を除き、自ら実施しているクラウドファンディングに対して支援者として支援を行うことはできないものとします。
                <br />
                <br />
                2.
                前項の定めは、実行者が、他の支援者に代わって自らが実施しているクラウドファンディングに対して支援を行うことを妨げるものではありません。ただし、実行者がかかる支援を行った場合、RFは、実行者に対し、当該第三者の氏名又は名称、連絡先その他RF所定の情報を提供し、また、本CFサービス上で必要な表示を行うように求めることができるものとします。
                <br />
                <br />
                3.
                RFは、RFの判断で本条に違反する支援を遡及的に取り消すことができるものとします。
                <br />
              </p>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第16条（クラウドファンディングの中止）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、RFの承認を得た場合に限り、クラウドファンディングを中止すること（クラウドファンディングを開始した後に支援の受付けを中止すること）ができるものとします。
                <br />
                <br />
                2.
                クラウドファンディングの中止その他実行者の都合により支援者に対する支援金の返金が行われた場合、返金等事務手数料として、RFはその判断により支援者数に応じた以下の金額（税別）を実行者に対して請求することができるものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1) 支援者数が1名以上10名未満の場合 10,000円
                <br />
                (2) 支援者数が10名以上20名未満の場合 15,000円
                <br />
                (3) 支援者数が20名以上30名未満の場合 20,000円
                <br />
                (4)
                支援者数が30名以上の場合、前号までの定めに準じ、支援者数が10人増加するごとに（30名以上40名未満、40名以上50名未満など）、前号の定める金額に5,000円ずつ加算して返金等事務手数料が計算されます。
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                3.
                サポートプラン又はコンサルティングプランが適用される実行者は、クラウドファンディングの中止により、本規約の別途定めるところに従いキャンセル料が発生することを確認するものとします。
                <br />
                <br />
                4.
                クラウドファンディングが達成後に中止された場合、RFはその判断により中止時点の支援総額により算定されるクラウドファンディング実施手数料相当額を実行者に対して請求することができるものとします。
              </p>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第17条（プロジェクトの実行及びリターンの提供）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、クラウドファンディングが成立した場合、支援者及びRFに対し、以下に定める義務を負います。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)プロジェクトページの内容に従ってプロジェクトを実行すること
                <br />
                (2)プロジェクトページの内容に従って支援金（目標金額を超えて行われた支援分を含みます。）を使用すること
                <br />
                (3)プロジェクトページの内容に従って支援者に対してリターンを提供すること
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                2.
                実行者は、前項に定める義務のいずれかを履行せず、又は履行できないおそれが生じた場合、直ちにRFに対してその旨を通知するものとし、RFとの間で対応を誠実に協議するものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第18条（終了報告及びリターンの提供報告等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、前条第1項第1号及び第2号に定める義務の履行と関連し、プロジェクト実施完了日の1週間後（ただし、プロジェクト実施完了日が支援募集期間の満了日より前の日の場合は支援募集期間の満了日の1週間後）の日までに、プロジェクトを実行した上でプロジェクトページを更新し、プロジェクトの実行を完了した旨の終了報告を支援者向けに行うものとします。当該終了報告においては、プロジェクトの経過、支援金の使途などの説明を行うものとします。
                <br />
                <br />
                2.
                実行者は、前条第1項第3号の義務の履行と関連し、リターンの提供を完了した場合はRF所定の管理機能を用いてリターンの提供ステータスについて更新し、また、プロジェクトページを更新してその旨を支援者向けに報告するものとします。
                <br />
                <br />
                3.
                実行者は、前二項に定める報告のほか、プロジェクトページの更新を積極的に更新し、プロジェクトを実行し、又はリターンを提供する過程を積極的に支援者と共有するように努めるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第19条（情報提供等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                RFは、クラウドファンディングの公開前後にかかわらず、実行者に対し、実行者又はその実施するクラウドファンディングに関する情報提供又は資料の提出を求めることができるものとします。
                <br />
                <br />
                2.
                前項に定める求めがあった場合、実行者は速やかにRFに対する情報提供又は資料の提出に応じるものとします。また、実行者は事実に合致していない情報や、誤導又は誤認のおそれのある情報を提供しないものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第20条（契約違反又はそのおそれがある場合の措置）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                RFは、以下に定める場合、RFの判断で、次項に定める措置を講じることができるものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)プロジェクトページの内容に従ってプロジェクトが実行されない具体的なおそれが生じた場合
                <br />
                (2)プロジェクトページの内容に従って支援金が使用されない具体的なおそれが生じた場合
                <br />
                (3)プロジェクトページの内容に従ってリターンが提供されない具体的なおそれが生じた場合
                <br />
                (4)実行者がRFとの間の契約上の義務又は表明保証に違反し、又はその具体的なおそれが生じた場合
                <br />
                (5)上記各号に準じる事由が生じた場合
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                2.
                RFは、前項各号に定める事由が生じた場合、その判断により実行者に事前に（やむを得ない場合は事後速やかに）通知した上で以下の措置をとることができるものとし、実行者はこれに異議を述べないものとします。また、実行者は、以下に掲げるいずれかの要請があった場合、速やかにこれに応じるものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)実行者に対するプロジェクトページの更新、支援者に対する個別の通知その他の方法による支援者その他のユーザー向けの事実経緯等の説明の要請
                <br />
                (2)RF自ら行う前号に定める説明の実施
                <br />
                (3)全部又は一部のリターンの販売停止、クラウドファンディングの中止
                <br />
                (4)支援金の引渡し留保（なお、RFが本項に基づき実行者に対する引渡しを留保した支援金について利息又は遅延損害金は発生しないものとします。）
                <br />
                (5)全部又は一部の支援のキャンセル
                <br />
                (6)実行者に対する全部又は一部の支援者への支援金の返金の要請
                <br />
                (7)実行者の氏名・名称、メールアドレスその他の連絡先の支援者に対する提供
                <br />
                (8)サービスの全部又は一部の提供の中止
                <br />
                (9)その他RFが必要と判断する措置
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                3.
                本条の定めに従いクラウドファンディングが中止された場合、RFは、実行者に対し、本規約上の定めに従い、サポートプラン又はコンサルティングプランが適用される場合におけるキャンセル料、返金等事務手数料及びクラウドファンディング実施手数料相当額を請求することができるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第21条（クラウドファンディング実施手数料）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                クラウドファンディングが達成した場合、実行者のRFに対する所定のクラウドファンディング実施手数料（その内容は実行者に適用されるプランを踏まえ、RF及び実行者が書面又は電磁的方法により合意するものとします。）が発生します。なお、実行者及びRFがクラウドファンディング実施手数料の負担者を別途定めた場合はこの限りではありません。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第22条（支援金の引渡し）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者がRF所定の早期入金オプションを利用した場合その他RF及び実行者が別途合意した場合を除き、RFは、クラウドファンディングが成立した場合、実行者に対し、支援募集期間の満了日の属する月の翌々月10日（銀行休業日の場合は前営業日）までに支援金を引き渡すものとします。なお、実行者及びRFが支援金の引渡先を別途合意した場合、RFは当該引渡先に対して支援金を引き渡すものとします。
                <br />
                <br />
                2.
                前項に定める支払いは、RF及び実行者が別途合意した場合を除き、実行者が本CFサービス上で入力し、RFが承認した銀行口座に振り込む方法により行います。なお、当該銀行口座に誤りその他の理由により銀行振込みによる支援金の引渡しに支障が生じた場合、実行者はRFから支援金の引渡しを受けられない場合があることを確認するものとします。
                <br />
                <br />
                3.
                RFは、RF及び実行者が別途合意した場合を除き、支援金を引き渡す際にクラウドファンディング実施手数料（オプションサービス料が発生する場合は当該オプションサービス料を含みます。）を控除する方法により、実行者からその支払いを受けることができるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第23条（支援者の個人情報の取扱い）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                RFは、支援者の個人情報を、本CFサービスのシステム上で所定の方法により提供する方法で提供するものとし、RFが別途認める場合を除き、これとは異なる方法により支援者の個人情報を実行者に提供しないものとします。
                <br />
                <br />
                2.
                実行者は、本CFサービスの利用に起因又は関連して取得した支援者の個人情報を、個人情報の保護に関する法律その他の関係法令に従って厳正に取り扱うものとします。
                <br />
                <br />
                3.
                実行者は、支援者の同意がある場合を除き、本CFサービスの利用に起因又は関連して取得した支援者の個人情報を以下に定める目的を超えて利用してはならず、また、支援者の同意なく支援者の個人情報を第三者に提供又は開示してはならないものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)
                リターンの提供、活動状況の報告その他支援契約に関連する合理的なコミュニケーション
                <br />
                (2)
                本CFサービスその他のRFの運営するサービス上で行う寄付、支援の募集に対する依頼、勧誘
                <br />
                (3) 実行者の資金調達活動又はマーケティング活動の分析、改善
                <br />
                (4)
                特定非営利活動法人である実行者がパブリック・サポート・テストにおいて支援者を寄付者として取り扱うこと
                <br />
                (5) その他プロジェクトページに明記した目的
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                4.
                実行者が取得した支援者の個人情報について、漏えい、滅失又は毀損、若しくはそのおそれがある事象（以下「漏えい等」といいます。）が生じた場合、直ちにRFに連絡するものとします。また、この場合、実行者は、漏えい等による二次被害の拡大を防止するために、支援者に対する通知その他の必要な対応を行うものとします。
                <br />
                <br />
                5.
                実行者は、本CFサービスの利用に起因又は関連して取得した支援者の個人情報を利用する必要がなくなったときは、支援者の個人情報を遅滞なく消去するものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第24条（その他の誓約事項）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者は、RFの事前の承諾なく、プロジェクトページ（本CFサービス上で作成中のものを含みます。本条において同じです。）を本CFサービス以外に転載しないものとします。
                <br />
                <br />
                2.
                実行者は、RFの事前の承諾なく、支援募集期間中、クラウドファンディングにおける支援金の使途と同一の資金使途を掲げて、クラウドファンディングの実施その他これに準じる寄付、支援の募集を実施してはならないものとします。
                <br />
                <br />
                3.
                実行者は、RFの事前の承諾なく、本CFサービス上で寄付、支援募集を行うウェブサイトにリンクすることその他これに準じる行為を行ってはならないものとします。
                <br />
                <br />
                4.
                実行者は、RFの事前の承諾なく、クラウドファンディングに対する支援金（クラウドファンディングを実施している事実やプロジェクトページを訴求して実行者自ら又は第三者が募集した寄付金、支援金を含みます。）を本CFサービス外で収納してはならないものとします。本項に反して実行者が寄付金、支援金を収納した場合、RFはその判断により実行者が収納した寄付金、支援金をクラウドファンディングに対する支援とみなし、実行者に対してクラウドファンディング実施手数料等を請求できるものとします。
                <br />
                <br />
                5.
                実行者がRFの提携するパートナーの紹介に基づき本CFサービスを利用する場合、RFが当該パートナーに対してクラウドファンディングの準備又は実施の状況その他の事項を合理的な範囲内で提供することに同意するものとします。
                <br />
                <br />
                6.
                実行者は、クラウドファンディングにプロジェクトの内容と関連性の乏しいタグを設定してはならないものとします。RFは、RFの判断で本項に違反し、又はそのおそれのあるタグを削除することができるものとします。
                <br />
                <br />
                7.
                実行者は、プロジェクトの終了報告及びリターン提供に関する報告をすべて完了するまでの間に、実行者について以下に定める事由が生じた場合、遅滞なく書面又は電磁的方法によりRFに通知するものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1) 事業の全部又は重大な一部を停止する場合
                <br />
                (2) 解散する場合その他清算手続に移行する場合
                <br />
                (3) 代表者を変更した場合
                <br />
                (4) 住所を変更した場合
                <br />
                (5)
                その他実行者の組織又は事業運営に関して重大な変更があった場合（認定NPO法人については、認定が取り消された場合を含みます。）
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="yonsyo" />
                <h2 style={{ textAlign: "center" }}>
                  {" "}
                  第4章　早期入金オプションサービス
                </h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第25条（本条の適用関係）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                実行者が、RFが本CFサービスに付随して提供するオプションサービスのうち、早期入金オプションサービスを利用する場合、本章の定めに従うものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第26条（申込み及び承諾）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者が早期入金オプションサービスの利用を希望する場合、RFに対し、RF所定の期限までに、RF所定の方法により早期入金オプションサービスの利用の申込みを行うものとします。
                <br />
                <br />
                2.
                実行者がオプションサービスの利用の申込みを行った場合であっても、RFは、RFの判断により、オプションサービスの利用を承諾しない場合があります。なお、RFは、申込みを承諾しない場合であっても、実行者に対して承諾しない理由を通知する義務を負わず、また、実行者はRFの判断に対して異議を述べないものとします。
                <br />
                <br />
                3.
                RF及び実行者の間で早期入金オプションサービスの利用に係る契約が成立した場合（実行者が第1項の定めに従い早期入金オプションサービスの利用の申込みを行い、RFがこれを承諾してクラウドファンディングが公開された場合や、クラウドファンディングの公開後に実行者が早期入金オプションサービスの利用を申し込み、RFがこれを拒否しなかった場合を含みます。）、RFが特別に認めた場合を除き、実行者は早期入金オプションサービスの利用申込みの撤回、当該契約の解除、取消し等はできないものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第27条（早期入金オプションサービス）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                実行者がRF所定の早期入金オプションサービスを利用した場合、RFは、支援募集期間終了日（ただし、当該日が土日の場合は翌営業日）が属する週（月曜日から始まる7日間を指すものとします。）の翌週3営業日以内に実行者に対して支援金を引き渡すものとします。
                <br />
                <br />
                2.
                早期入金オプションサービスの手数料は、RF及び実行者が別途合意した場合を除き、支援総額の3.0%に相当する金額（ただし、150,000円を上限とします。）又は30,000円のいずれか高い金額（消費税及び地方消費税別途）とします。ただし、実行者は、RFから支援金の引渡しを受けた場合に限り、RFに対して当該手数料を支払う義務を負うものとします。
                <br />
                <br />
                3.
                RFは、RF及び実行者が別途合意した場合を除き、実行者に対して支援金を引き渡す際に前項に定める手数料を控除する方法により、実行者から当該手数料の支払いを受けることができるものとします。
                <br />
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="gosyo" />
                <h2 style={{ textAlign: "center" }}>
                  {" "}
                  第5章　支援者に関するルール
                </h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第28条（クラウドファンディングへの支援）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者は、支援募集期間中に本CFサービス上でRF所定の方法により支援を確定する操作を行うことにより、クラウドファンディングに対する支援を行うことができるものとします。なお、支援者による支援の確定に関するデータがRF所定のサーバに送信され、RFのシステム上反映された時点をもって有効に支援が行われたものとして取り扱われます。
                <br />
                <br />
                2.
                支援者は、支援をキャンセルすることを予定して支援を行うなど、支援を行う意思なく、又はいたずら目的で支援を行ってはならないものとします。
                <br />
                <br />
                3.
                支援者は、支援に際してリターンの郵送先の宛先その他の選択するリターンの性質に応じて必要となる情報を入力する場合、真実かつ正確な情報を入力するものとします。なお、RFが別途承諾した場合を除き、支援の完了後は当該情報を変更することができないものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第29条（支援に関する情報）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者は、RFが実行者（外国にある実行者を含みます。）に対して支援者のユーザー名、メールアドレス、選択したリターンの内容その他支援に関する事項（リターンの郵送に必要な情報として氏名、電話番号、郵便番号、住所などを入力した場合はこれらの情報を含みます。）を提供することに同意した上で支援を行うものとします。また、RFは、本CFサービスの提供に必要な範囲で支援に関する情報を決済代行会社、金融機関等に提供する場合があります。
                <br />
                <br />
                2.
                支援者は、RF所定の「応援コメント」に支援者のユーザー名、プロフィール写真及び支援者が入力したコメントの内容が表示されることに同意した上で支援を行うものとします。
                <br />
                <br />
                3.
                支援者は、支援したクラウドファンディングの情報及び支援したクラウドファンディングの数が本CFサービス上で表示されることに同意した上で支援を行うものとします。なお、支援者は、RF所定の方法により本項に定める表示を停止することができます。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第30条（支援時の留意事項）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者は、プロジェクトページの内容を十分に理解し、かつ、将来のプロジェクトの実行やリターンの提供が一定のリスク、不確実性を伴うことを理解した上で、自己責任でクラウドファンディングに対する支援を行うものとします。
                <br />
                <br />
                2.
                RFは、支援契約の当事者となるものではなく、支援契約に基づく義務（プロジェクトの実行やリターンの提供を含みます。）及び責任を負わず、また、支援契約に基づく義務が履行されることを保証するものではありません。支援者は、プロジェクトの実行、支援金の使用、リターンの提供その他の支援契約に関する事項については、本サービスのメッセージ機能を利用する方法その他の方法により直接実行者に一次的な問合せを行うものとします。
                <br />
                <br />
                3.
                支援者が本CFサービス上で支援に係る情報を送信した後に支援が有効に行われたものとして取り扱われるまでにタイムラグが生じる場合があり、特に支援募集期間の満了する直前に支援に係る情報が送信された場合、有効な支援として取り扱われない場合があります。
                <br />
                <br />
                4.
                支援者は、自らが支援を行った後に新たにリターンの追加等が行われる場合があること、その他プロジェクトページの内容が変更される場合があることを確認するものとします。
                <br />
                <br />
                5.
                支援金の支払いに関する領収証の発行主体は実行者となります。領収証の発行に関しては実行者に直接お問い合わせください。なお、RFは、支援者の求めに応じ、支援に関する証明書を発行する場合がありますが、本CFサービス上で支援が行われた旨を証するものであり、領収証とは異なります。
                <br />
                <br />
                6.
                登録ユーザーが他の者から金銭を預かるなどして当該他の者に代わって登録ユーザーが支援を行った場合であっても、本規約の適用上、当該登録ユーザーが支援者として取り扱われます。この場合、当該登録ユーザーの責任において、当該支援に関する情報（当該他の者の氏名、連絡先、支援額、希望するリターン、リターン送付先住所を含みます。）を管理すること、クラウドファンディングが成立しなかった場合に当該他の者に返金を行うことその他当該他の者との合意に従った対応を行うものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第31条（支援者システム利用料）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                支援者がクラウドファンディング(寄付金控除型クラウドファンディングのうち、支援者がふるさと納税に係る税制上の優遇措置を受けることができるものを除きます。また、プロジェクトページの公開開始が
                2022 年 3 月 1
                日以降のものに限ります。)に対して支援を行う際には、RF
                が特別に認める場合を除き、支援者の RF に対する RF
                所定の支援者システム利用料が発生します。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第32条（支援のキャンセル）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                本規約の定めに従い支援がキャンセルされた場合、支援、支援契約及び支援者システム利用料の支払いは遡及的に取り消されるものとします。
                <br />
                <br />
                2.
                クラウドファンディングが成立しなかった場合、支援はキャンセルされます。
                <br />
                <br />
                3.
                支援者は、RFが特別に認める場合を除き、クラウドファンディングの達成前に限り、RF所定の方法により、自らの行った支援をキャンセルすることができます。なお、All
                or
                Nothing方式で実施されるクラウドファンディングについては支援総額が目標金額を達成した時点で、All
                In方式で実施されるクラウドファンディングについては支援総額が1円に達した時点で達成したものとして取り扱われます。
                <br />
                <br />
                4.
                RFは、支援募集期間の満了前か否かにかかわらず、実行者又は支援者が本規約上の義務又は表明保証に違反し、又はその具体的なおそれが生じた場合、その他RFが必要と認める場合、その判断で支援をキャンセルすることができるものとします。
                <br />
                <br />
                5.
                支払いの完了後に支援がキャンセルされた場合、RFは選択された支払手段に応じてRF所定の時期及び方法により支援者に対して支援金及び支援者システム利用料の返金を行います。
                <br />
                <br />
                6.
                支援がキャンセルされた場合であっても、支援金及び支援者システム利用料に利息は発生しないものとします。
                <br />
                <br />
                7.
                支援者は、支援がキャンセルされた場合であっても、RFが実行者に対して支援に関する情報を提供する場合があり、その情報に支援のキャンセルに関する情報が含まれる場合があることに同意するものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第33条（カード決済による支援）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者が支払手段としてカード決済を選択して支援を行った場合、クラウドファンディングが達成した時点でカード決済が実行されます。
                <br />
                <br />
                2.
                何らかの理由でRF所定の期限までにカード決済が実行されなかった場合又はカード決済による支援についてチャージバック請求等により決済が取り消された場合、RFは支援をキャンセルすることができるものとします。
                <br />
                <br />
                3.
                クラウドファンディングの中止その他の理由によりクラウドファンディングの達成後にカード決済による支援がキャンセルされた場合、カード会社を通じて決済の取消し又は返金が行われます。詳細はカード会社にお問い合わせください。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第34条（銀行振込みによる支援）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者が支払手段として銀行振込みを選択して支援を行う場合、RFが別途指定する銀行口座に、RF所定の振込期限までに、RFのシステム上で選択した支援金額(支援者システム利用料が発生する場合は支援者システム利用料を含みます。本条において同じです。)を一回払いで振り込むものとします。なお、振込手数料は支援者の負担とします。また、支援者が銀行振込みによる支援を行う場合、RFに対し、RF所定の方法により、返金用の銀行口座を通知するものとします。
                <br />
                <br />
                2.
                振込先の銀行口座に誤りがある場合、振込金額に誤りがある場合（振込金額が支援金額より大きい場合を含みます。）、振込期限後に振込みが行われた場合その他の支援者による銀行振込みが前項の定めに従っていない場合、RFは、第1項の定めに従った銀行振込みが行われたものとして取り扱わず、必要に応じ、前項に定める返金用の銀行口座に振り込む方法により、支援金の返金を行います。
                <br />
                <br />
                3.
                第1項の定めに従った銀行振込みが行われない場合、RFは支援をキャンセルすることができるものとします。
                <br />
                <br />
                4.
                第1項の定めに従った銀行振込みの完了後に銀行振込みによる支援がキャンセルされた場合、RFは、第1項に定める返金用の銀行口座に振り込む方法により、支援金の返金を行います。本項に定める支援金の返金に関し、振込手数料はRFが負担します。
                <br />
                <br />
                5.
                前項に定める支援金の返金に関し、第1項に定める返金用の銀行口座の誤りその他の理由により銀行振込みによる返金に支障が生じた場合において、RFが支援者に対してその旨を最初に通知した日から6か月以内に、支援者がRFに対して振込可能な銀行口座の情報を通知しないとき、その他銀行振込みによる返金が著しく困難なときは、その金銭の処分はRFに委ねられたものとみなされます。この場合、支援者はRFから返金を受けられない場合があることを確認するものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第35条（コンビニ決済による支援）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者が支払手段としてコンビニ決済を選択して支援を行う場合、RFが別途指定する方法で、RF所定の期限までに、RFのシステム上で選択した支援金額（支援者システム利用料が発生する場合は支援者システム利用料を含みます。本条において同じです。）を一回払いで支払うものとします。また、支援者がコンビニ決済による支援を行う場合、RFに対し、RF所定の方法により、返金用の銀行口座を通知するものとします。
                <br />
                <br />
                2.
                支援者によるコンビニ決済が前項の定めに従っていない場合、RFは、第1項の定めに従ったコンビニ決済が行われたものとして取り扱わず、必要に応じ、前項に定める返金用の銀行口座に振り込む方法により返金を行います。
                <br />
                <br />
                3.
                第1項の定めに従ったコンビニ決済が行われない場合、RFは支援をキャンセルすることができるものとします。
                <br />
                <br />
                4.
                第1項の定めに従ったコンビニ決済の完了後にコンビニ決済による支援がキャンセルされた場合、RFは、第1項に定める返金用の銀行口座に振り込む方法により返金を行います。本項に定める返金に関し、振込手数料はRFが負担します。
                <br />
                <br />
                5.
                前項に定める返金に関し、第1項に定める返金用の銀行口座の誤りその他の理由により銀行振込みによる返金に支障が生じた場合において、RFが支援者に対してその旨を最初に通知した日から6か月以内に、支援者がRFに対して振込可能な銀行口座の情報を通知しないとき、その他銀行振込みによる返金が著しく困難なときは、その金銭の処分はRFに委ねられたものとみなされます。この場合、支援者はRFから返金を受けられない場合があることを確認するものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="rokusyo" />
                <h2 style={{ textAlign: "center" }}>第6章　その他</h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>第36条（免責等）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                RFは、本CFサービス上で実施されたクラウドファンディングについて、以下の事項を含む一切の事項について何らの表明及び保証も行うものではありません。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                (1)
                プロジェクトページに記載されている情報が、最新、正確かつ真実に適合するものであること
                <br />
                (2)
                プロジェクトの実施及びリターンの提供が、実行者又は支援者に適用のある法令又は規則に抵触しないこと又は公序良俗に反しないこと
                <br />
                (3) プロジェクトページの内容に従ってプロジェクトが実行されること
                <br />
                (4) プロジェクトページの内容に従って支援金が使用されること
                <br />
                (5) プロジェクトページの内容に従ってリターンが提供されること
                <br />
                (6)
                プロジェクト及びリターンが支援者の期待する性質、品質、財産的価値その他の性能を備えていること
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                2.
                RFは、本CFサービス上に掲載された個々のプロジェクトページの内容に関し、支持・不支持その他の意見を表明するものではありません。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第37条（本規約の変更）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                RFが本規約を変更した場合、本CFサービスに係るウェブサイト上で変更後の本規約を公表する方法その他の方法によりユーザーに対して周知します。
                <br />
                <br />
                2.
                ユーザーは、本規約の変更後に本CFサービスを利用した場合には、本規約の変更に同意したものとみなされます。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>第38条（一般条項）</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定は、継続して完全に効力を有するものとします。
                <br />
                <br />
                2.
                本規約は日本法を準拠法とし、日本法に従って解釈されるものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <div className="body">
              <span style={{ fontSize: "150%" }}>
                <h2 id="betten" />
                <h2 style={{ textAlign: "center" }}> 別添　支援契約について</h2>
              </span>
              <br />
            </div>
          </div>
          <div className="paragraph">
            <h2>●支援契約の成否</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                本CFサービス上でクラウドファンディングに対する支援が行われた場合、本規約の定めに従って実行者と支援者との間で支援契約が成立します。
                <br />
                <br />
                2.
                本規約の定めに従い支援がキャンセルされた場合、支援契約は遡及的に取り消されるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>●支援契約の内容</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                支援者は、本規約の定めに従い実行者に対して支援金を支払う義務を負います。
                <br />
                <br />
                2.
                実行者は、支援者に対し、プロジェクトページの内容に従ってプロジェクトを実行し、支援金を使用し、また、リターンを提供する義務を負います。
                <br />
                <br />
                3.
                支援契約の成立後にプロジェクトページの内容（プロジェクト及びリターンに関する事項を含みます。）が変更された場合、プロジェクトの趣旨及び目的の同一性、支援者に及ぶ影響の性質、大小その他の変更に係る事情に照らして合理的な範囲内の変更であることを条件として支援契約の内容も変更されるものとします。
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>●命名権、メッセージの掲載その他これに類するリターン</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                1.
                命名権、メッセージの掲載その他これに類するリターンを選択して行う支援に関しては、支援者が以下に該当する名称又は表現等を使用した場合であっても、実行者は当該支援者の指示に従わないことができるものとし、この場合であっても、支援者に対する支援金の返金は行われないものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                ①法律・条例に違反するもの
                <br />
                ②公序良俗に反するもの
                <br />
                ③政治活動又は宗教活動に関するもの
                <br />
                ④実行者又は第三者の名誉・信用、知的財産権その他の権利を侵害するもの
                <br />
                ⑤その他実行者が不適切であると合理的に判断するもの
                <br />
                <br />
              </p>
              <p style={{ paddingLeft: "1em" }}>
                2.
                実行者は、支援者が前項に定めるリターンに係る権利行使を行う時期及び方法を定めることができるものとし、支援者が当該時期及び方法に従わなかった場合であっても、支援者に対する支援金の返金は行われないものとします。
                <br />
                <br />
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>●禁止事項</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                支援者及び実行者は、支援契約に起因又は関連して、相手方又は第三者に対し、以下に定める行為（以下に定める行為のいずれかを援助又は助長する行為を含みます。）を行ってはならないものとします。
                <br />
              </p>
              <p style={{ paddingLeft: "2em" }}>
                ①法令、裁判所の判決、決定若しくは命令、又は法令上拘束力のある行政措置に違反する行為
                <br />
                ②嫌がらせ、不当な要求行為、誹謗中傷
                <br />
                ③相手方又は第三者の著作権、商標権、特許権等の知的財産権、名誉権、プライバシー権その他法令上又は契約上の権利を侵害する行為
                <br />
                ④公の秩序又は善良の風俗を害するおそれのある行為
                <br />
                ⑤宗教活動又は宗教団体への勧誘行為
                <br />
                ⑥性行為やわいせつな行為を目的とする行為
                <br />
                ⑦商用、営業又は宣伝を目的とする行為
                <br />
                ⑧支援契約の目的に合致しない行為
                <br />
                ⑨その他上記各号に準じる行為
                <br />　
              </p>
            </div>
          </div>
          <div className="paragraph">
            <h2>●適用関係</h2>
            <div className="body">
              <p style={{ paddingLeft: "1em" }}>
                プロジェクトページの内容が本別添に定める内容と矛盾又は抵触する場合、プロジェクトページの内容が優先されるものとします。
                <br />
              </p>
            </div>
          </div>
        </section>
        <ul id="breadcrumbs">
          <li>
            <Link onClick={toTop} to="/">
              ←戻る
            </Link>
          </li>
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
